import { render, staticRenderFns } from "./MemberLayout.vue?vue&type=template&id=0cc89db1"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MemberLayout.vue"
export default component.exports